import { render, staticRenderFns } from "./ListaDeVacantes.vue?vue&type=template&id=0586aa2c&scoped=true"
import script from "./ListaDeVacantes.vue?vue&type=script&lang=js"
export * from "./ListaDeVacantes.vue?vue&type=script&lang=js"
import style0 from "./ListaDeVacantes.vue?vue&type=style&index=0&id=0586aa2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586aa2c",
  null
  
)

export default component.exports